import { registerPlugin } from '@capacitor/core';
const PhonePePaymentPlugin = registerPlugin('PhonePePaymentSDK');
export * from './definitions';
export { PhonePePaymentPlugin };
//# sourceMappingURL=index.js.map